import { render, staticRenderFns } from "./MsalespeopleView.vue?vue&type=template&id=5226dca8&scoped=true"
import script from "./MsalespeopleView.vue?vue&type=script&lang=js"
export * from "./MsalespeopleView.vue?vue&type=script&lang=js"
import style0 from "./MsalespeopleView.vue?vue&type=style&index=0&id=5226dca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5226dca8",
  null
  
)

export default component.exports